var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-row flex-grow-1 flex-fill justify-center",class:[_vm.center ? 'align-center' : ''],staticStyle:{"overflow":"hidden"},style:({ ..._vm.styles })},[_c('v-progress-circular',{attrs:{"size":_vm.size,"width":"3","color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }